import baseAssetsModule from '../baseAssets/module';

const mq = window.matchMedia('(max-width: 740px)');
const isMobile = mq.matches;

export const appBarService = {
    getMobileOperatingSystem: () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }
    
        if (/android/i.test(userAgent)) {
            return 'Android';
        }
    
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }
    
        return 'unknown';
    },
    downloadAppBarInit: () => {
        const gdprCookieExists = baseAssetsModule.getCookie('gdprCookie')
            || baseAssetsModule.getCookie('__Host-gdprCookie');
        const oldDownloadAppCookie = baseAssetsModule.getCookie('downloadAppCookie');
        const downloadAppLinkHidden = oldDownloadAppCookie
            || baseAssetsModule.getCookie('__Host-downloadAppCookie')
            || !gdprCookieExists;
        if (oldDownloadAppCookie !== '') {
            baseAssetsModule.setCookie('downloadAppCookie', '', -1);
            const oldDownloadAppCookieValue = oldDownloadAppCookie === 'true';
            baseAssetsModule.setCookie('__Host-downloadAppCookie', oldDownloadAppCookieValue, 365);
        }
    
        const $body = $('.js_body');
        const $header = $('.js_header')
        const $headerDesktopBannerBar = $('.headerDesktopBannerBar');
    
        if (!$headerDesktopBannerBar.length) {
            $body.removeClass('withTopBanner');
            $header.css('top', 0);
        }
    
        if (!$headerDesktopBannerBar.length && isMobile) {
            $body.removeClass('withTopBannerMobile');
            $header.css('top', 0);
        }
    
        if (!$('.js_download-app-bar').length) {
            return;
        }
    
        if (!downloadAppLinkHidden) {
            $('.js_header-banner').addClass('hideOnMobile');
            $('body').removeClass('withTopBannerMobile');
            $('.js_download-app-bar').removeClass('hidden');
            $('body').addClass('withDownloadAppBar');
        }
    
        $('.js_download-app-bar_close').click((event) => {
            baseAssetsModule.setCookie('__Host-downloadAppCookie', true, 365);
            $('body').removeClass('withDownloadAppBar');
            $('.js_download-app-bar').addClass('hidden');
            $('body').removeClass('with-app-banner-search');
        });
    
        $('.js_download-app-bar_link').click((event) => {
            event.preventDefault();
            const deviceOS = appBarService.getMobileOperatingSystem();
    
            switch (deviceOS) {
                case 'Android' :
                    window.location.href = 'https://play.google.com/store/apps/details?id=nl.futurumshop&hl=nl';
                    break;
                case 'iOS' :
                    window.location.href = 'https://apps.apple.com/tt/app/futurumshop/id1495969902?ign-mpt=uo%3D2';
                    break;
            }
    
            baseAssetsModule.setCookie('__Host-downloadAppCookie', true, 365);
            $('.js_download-app-bar').addClass('hidden');
        });
    },
};